import { Table } from 'ui/table';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableRows } from 'ui/tableRows';

import { IntegrationsHeader } from './IntegrationsHeader';
import { MovableInkIntegrationModals } from '../modals';
import { useIntegrationContext } from '../contexts/IntegrationContext';
import { useTableColumns } from '../hooks/useTableColumns';
import { EmptyIntegrationsState } from './EmptyIntegrationsState';
import {
  TableContainer,
  StyledTableHeader,
  StyledPaginationFooter,
} from './IntegrationsPage.styles';

export const IntegrationsPage = () => {
  const { integrations } = useIntegrationContext();

  const {
    currentPage,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: integrations,
    sortedBy: 'updatedAt',
  });

  const columns = useTableColumns();

  return (
    <>
      <IntegrationsHeader />
      <TableContainer className="table-container">
        <Table>
          <StyledTableHeader
            columns={columns}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            sortedBy={sortedBy}
            setSortedBy={setSortedBy}
          />
          {rows.length === 0 ? (
            <EmptyIntegrationsState />
          ) : (
            <TableRows columns={columns} rows={rows} />
          )}
        </Table>
      </TableContainer>
      <StyledPaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
      <MovableInkIntegrationModals />
    </>
  );
};
